<template>
  <div class="skeleton-chart-bars">
    <div class="skeleton-chart-bars__col" :class="colClasses" />
    <div class="skeleton-chart-bars__col" :class="colClasses" />
    <div class="skeleton-chart-bars__col" :class="colClasses" />
    <div class="skeleton-chart-bars__col" :class="colClasses" />
    <div class="skeleton-chart-bars__col" :class="colClasses" />
    <div class="skeleton-chart-bars__line" />
    <div v-if="!static" class="skeleton-chart-bars__message">{{ message }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  message?: string
  static?: boolean
}

const { message = 'Chart is loading...', static: isStatic } =
  defineProps<Props>()

const colClasses = computed(() => ({
  'skeleton-chart-bars__col--static': isStatic,
}))
</script>

<style>
.skeleton-chart-bars {
  @apply relative;
  @apply flex justify-between;
  @apply w-[80%] h-[16.25rem];
  @apply ml-auto;
  @apply mb-10 px-3;

  &__col {
    @apply w-[18%] max-w-[3rem];
    @apply bg-gray-300 dark:bg-gray-700;
    @apply animate-pulse;
    @apply second:mt-10 second:animation-delay-200;
    @apply third:mt-5 third:animation-delay-400;
    @apply fourth:mt-16 fourth:animation-delay-600;
    @apply fifth:mt-12 fifth:animation-delay-800;

    &--static {
      @apply animate-none;
    }
  }

  &__line {
    @apply h-[1px];
    @apply absolute inset-x-0 bottom-0;
    @apply bg-gray-400 dark:bg-gray-500;
  }

  &__message {
    @apply absolute top-1/2 left-1/2;
    @apply -translate-x-1/2 -translate-y-1/2;
    @apply text-sm sm:text-xs;
    @apply text-gray-400 dark:text-gray-500;
    @apply text-center;
  }
}
</style>
